import React, { useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";

const AppUrlLoginStep = ({ onComplete }) => {
  const [appUrl, setAppUrl] = useState("");
  const [loginNotes, setLoginNotes] = useState("");

  const handleSubmit = () => {
    if (appUrl.trim()) {
      // Store app URL and login notes in localStorage for the stripe payment step
      localStorage.setItem('onboardingAppUrl', appUrl.trim());
      localStorage.setItem('onboardingLoginNotes', loginNotes.trim());
      
      onComplete();
    }
  };

  return (
    <Box 
      sx={{ 
        width: "100%",
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        py: 8,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: "600px",
          mx: "auto",
          px: 3,
          width: "100%",
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            color: "#ffffff",
            mb: 3,
            letterSpacing: "-0.02em",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
          }}
        >
          App Configuration
        </Typography>
        
        <Typography
          variant="h6"
          sx={{
            color: "#94a3b8",
            fontWeight: 400,
            mb: 6,
            lineHeight: 1.6,
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
          }}
        >
          Provide a public URL to your application and any login instructions for our testing system.
          <br/>
          <br/>
          Fume will explore the user flows to turn them into Playwright tests.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            mb: 6,
            maxWidth: "500px",
            mx: "auto",
          }}
        >
          <TextField
            fullWidth
            value={appUrl}
            onChange={(e) => setAppUrl(e.target.value)}
            placeholder="https://your-app.com"
            label="Public App URL"
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                color: '#fff',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                borderRadius: 2,
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.2)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
              },
              '& .MuiInputLabel-root': {
                color: '#94a3b8',
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
              },
            }}
          />

          <TextField
            fullWidth
            multiline
            rows={4}
            value={loginNotes}
            onChange={(e) => setLoginNotes(e.target.value)}
            placeholder="Login credentials, special instructions, etc."
            label="Login Information - just say no auth needed"
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                color: '#fff',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                borderRadius: 2,
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.2)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
              },
              '& .MuiInputLabel-root': {
                color: '#94a3b8',
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
              },
            }}
          />
        </Box>

        <Button
          fullWidth
          onClick={handleSubmit}
          disabled={!appUrl.trim()}
          sx={{
            maxWidth: "320px",
            height: 56,
            borderRadius: 2,
            background: appUrl.trim() ? "#ffffff" : "rgba(255, 255, 255, 0.3)",
            color: appUrl.trim() ? "#000000" : "#94a3b8",
            fontSize: "1.1rem",
            fontWeight: 600,
            textTransform: "none",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
            boxShadow: appUrl.trim() ? "0 4px 16px rgba(255, 255, 255, 0.2)" : "none",
            "&:hover": {
              transform: appUrl.trim() ? "translateY(-2px)" : "none",
              boxShadow: appUrl.trim() ? "0 8px 24px rgba(255, 255, 255, 0.25)" : "none",
              background: appUrl.trim() ? "#f8fafc" : "rgba(255, 255, 255, 0.3)",
            },
            "&:disabled": {
              color: "#64748b",
            },
          }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
};

export default AppUrlLoginStep; 